import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Utils
import { translation } from '../../../../utils/helpers'

// Components
import Text from '../../../elements/text'

class ChassisNumber extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }

  render () {
    return (
      <Text labelText={translation('81')} name='ChassisNumber' value={this.props.chassisNumber} onChange={this.props.onInputChange} autoComplete='off' />
    )
  }
}

ChassisNumber.propTypes = {
  chassisNumber: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired
}

export default ChassisNumber



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/ChassisNumber/index.js